import TermAccordion from '@components/term/TermAccordion';
import useTermCategories from '@hooks/term/useTermCategories';

import styles from './styles.module.scss';

interface Props {

}

function PrepaidCardNotes() {
  const termCategories = useTermCategories('PREPAY');
  return (
        <footer className={styles.container}>
            {termCategories.map((termCategory) => (
                <TermAccordion termCategory={termCategory}
                key={termCategory.id}/>
            ))}
        </footer>
  );
}

export default PrepaidCardNotes;
